import { useContext } from "react";

import { DynamicFormContext } from "containers/DynamicForm/DynamicFormContext";
import { EXPECTED_ACTION_ERROR } from "containers/DynamicForm/useButtonAction";
import { TApiButtonCommandFn } from "containers/DynamicForm/useButtonCommand";
import { useModal } from "modules";
import { isInputValueUnchanged } from "utils/form";

export const useFormUnchangedSubmitWarning = () => {
  const { inputs } = useContext(DynamicFormContext);
  const openModal = useModal();

  const formUnchangedSubmitWarningCommand: TApiButtonCommandFn = (commandArgs = []) => {
    const inputArguments = commandArgs.filter(input => input.sourceType === "input");
    const hasUnchangedFormData = inputArguments.every(inputArg =>
      isInputValueUnchanged(inputs[inputArg.source], inputArg)
    );

    if (hasUnchangedFormData) {
      openModal("NoPIUChangeErrorModal");
      throw Error(EXPECTED_ACTION_ERROR);
    }
  };

  return formUnchangedSubmitWarningCommand;
};
